<div class="fms-notification-bell">
  <button
    vng-icon-button
    color="none"
    type="button"
    aria-label="Notifications"
    [attr.aria-expanded]="isOpen"
    class="fms-notification-bell__trigger"
    data-fms-heap="fms-header-notification-bell"
    (click)="toggleDrawer()"
  >
    <vng-icon name="notifications" [outline]="false" color="inherit"></vng-icon>
    <vng-badge
      *ngIf="(unreadCount$ | async) as count"
      variant="error"
      size="sm"
      class="fms-notification-bell__badge"
    >
      {{ unreadLabel(count) }}
    </vng-badge>
  </button>
</div>
